import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";
import { app } from "./firebase.js";

export const functions = getFunctions(app);

if (import.meta.env?.DEV) {
  const host = typeof window !== "undefined" ? window.location.hostname : "127.0.0.1";
  try {
    connectFunctionsEmulator(functions, host, 5001);
  } catch (error) {
    console.warn("Functions emulator connection warning:", error.message);
  }
}

export const inviteChild        = httpsCallable(functions, "inviteChild");
export const acceptChildInvite  = httpsCallable(functions, "acceptChildInvite");
export const submitAttempt    = httpsCallable(functions, "submitAttempt");
export const checkRetryAnswer = httpsCallable(functions, "checkRetryAnswer");
export const generateSolution = httpsCallable(functions, "generateSolution");
export const selfProvisionParent = httpsCallable(functions, "selfProvisionParent");
export const selfProvision       = httpsCallable(functions, "selfProvision");
export const inviteCoParent       = httpsCallable(functions, "inviteCoParent");
export const acceptCoParentInvite = httpsCallable(functions, "acceptCoParentInvite");
export const approveCoParent      = httpsCallable(functions, "approveCoParent");
